import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import axios from 'axios';
import React, {Component, Fragment} from 'react';
import '../../index.css';
import { withStyles } from "@material-ui/core/styles";
import {format_number} from "../../../ClientUtils";
const root_string = require("../../../config.json")["root_string"];

const styles = theme => ({
	flexContainer: {
		display: 'flex',
		alignItems: 'center',
		boxSizing: 'border-box',
	},
	table: {
		'& .ReactVirtualized__Table__headerRow': {
			flip: false,
			paddingRight: theme.direction === 'rtl' ? '0 !important' : undefined,
		},
		maxBodyLength: 800,
		minWidth: 300,
	},
	tableRow: {
		cursor: 'pointer',
	},
	tableRowHover: {
		'&:hover': {
			backgroundColor: theme.palette.grey[200],
		},
	},
	tableCell: {
		flex: 1,
	},
	noClick: {
		cursor: 'initial',
	},
});

class V1AggregatedByBoughtVsSold extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			assets: [],
			data: {}
		};
	}
	
	componentDidMount() {
		axios
			.get(root_string + '/api/data_api/V1_aggregated_by_bought_vs_sold')
			.then(res => {
				let data = res.data.data;
				this.setState({
					data: data
				});
			})
			.catch(err => {
				console.log("Error from Get V1 Aggregated By Bought Vs Sold API");
			})
	};
	
	render() {
		const { classes } = this.props;
		return (
			<Fragment>
				<div>
					<TableContainer component={Paper}>
						<Table className={classes.table} aria-label="simple table">
							<TableHead>
								<TableRow>
									<TableCell>Stats By Bought Vs Sold Transaction</TableCell>
									<TableCell align="right">Total Volume</TableCell>
									<TableCell align="right">Total Premiums</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								<TableRow key={"Buy Option"}>
									<TableCell component="th" scope="row" style={{width: "30%"}}>
										Buy Option
									</TableCell>
									<TableCell  align="right">
										${ format_number(this.state.data["buy_volume"])}
									</TableCell>
									<TableCell align="right">
										${ format_number(this.state.data["buy_premium"])}
									</TableCell>
								</TableRow>
								<TableRow key={"Sell Option"}>
									<TableCell component="th" scope="row" style={{width: "30%"}}>
										Sell Option
									</TableCell>
									<TableCell  align="right">
										${ format_number(this.state.data["sell_volume"])}
									</TableCell>
									<TableCell  align="right">
										${ format_number(this.state.data["sell_premium"])}
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</div>
			</Fragment>
		);
	}
}

export default withStyles(styles, { withTheme: true })(V1AggregatedByBoughtVsSold);
